import getQueryParams from './getQueryParams';

export function isInIframe() {
  // same as app.jsx, if we got noLayout as a param with any value, we will render iframe mode
  return getQueryParams().noLayout != null;
}

export default isInIframe;
